import { globalObject } from "@faire/globals/index";
import get from "lodash/get";

export type GlobalLookup = <T>(prop: string) => T | undefined;

export const defaultLookup: GlobalLookup = <T>(prop: string): T | undefined => {
  return get(globalObject, prop);
};

let lookupOverride: GlobalLookup | undefined;

export const setGlobalLookup = (
  lookup: (<T>(prop: string) => T | undefined) | undefined
) => {
  lookupOverride = lookup;
};

export const getGlobalLookup = (): GlobalLookup => {
  return lookupOverride ?? defaultLookup;
};
